import React, { MouseEvent, ReactNode } from "react";
import styles from "./AppPopin.scss";

export type AppPopinProps = {
  opened: boolean;
  children: ReactNode;
  onModalClick?: (event: MouseEvent) => void;
  extendedStyle?: string;
};

const AppPopin = ({ opened, children, onModalClick, extendedStyle }: AppPopinProps) => {
  const modalClickHandler = (event: MouseEvent) => {
    if (onModalClick) {
      event.persist();
      onModalClick(event);
    }
  };

  // Permet d'éviter de déclencher le handler sur la modal lors d'un click dans le contenu
  const contentClickHandler = (event: MouseEvent) => {
    event.stopPropagation();
  };

  return (
    <div id="PopinModal" className={`${styles.popinModal} ${opened ? styles.opened : ""}`} onClick={modalClickHandler}>
      <div id="PopinContent" className={`${styles.popinContainer} ${extendedStyle}`} onClick={contentClickHandler}>
        {children}
      </div>
    </div>
  );
};

export default AppPopin;
